import { useAuth } from "@/lib/auth";
import { useTranslations } from "@/lib/useTranslations";

export function DashboardPage() {
  const { user } = useAuth();
  const t = useTranslations("dashboard");

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-6 overflow-y-auto px-6 py-10">
      <header className="space-y-1">
        <p className="text-sm font-medium uppercase tracking-widest text-neutral-500">
          {t("cockpit")}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-whart-text">
          {t("title")}
        </h1>
        <p className="text-sm text-neutral-500">
          {t("signedInAs", { email: user?.email ?? "" })}
        </p>
      </header>

      <section className="wireframe-border bg-whart-bg p-6">
        <p className="text-neutral-600">{t("placeholder")}</p>
      </section>
    </div>
  );
}
